// // src/context/AppContext.js
// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import { useAuth0 } from '@auth0/auth0-react';
// import { usersAPI, notebooksAPI } from '../services/api';

// const AppContext = createContext(null);

// function getExternalTokenFromUrl() {
//   try { return new URLSearchParams(window.location.search).get('token') || null; }
//   catch { return null; }
// }
// function getExtJwtFromUrl() {
//   try { return new URLSearchParams(window.location.search).get('ext_jwt') || null; }
//   catch { return null; }
// }

// const EXT_AUTH0_TOKEN_KEY = 'air_ext_auth0_token';
// function saveExtAuth0Token(t) { try { localStorage.setItem(EXT_AUTH0_TOKEN_KEY, t); } catch {} window.__AIR_ACCESS_TOKEN__ = t; }
// function loadExtAuth0Token() { try { return localStorage.getItem(EXT_AUTH0_TOKEN_KEY) || null; } catch { return null; } }
// function clearExtAuth0Token() { try { localStorage.removeItem(EXT_AUTH0_TOKEN_KEY); } catch {} }

// const INITIAL_EXT_TOKEN = getExternalTokenFromUrl();
// const INITIAL_EXT_JWT   = getExtJwtFromUrl();
// // Agar naya token URL mein hai toh purana clear karo
// if (INITIAL_EXT_TOKEN) { try { localStorage.removeItem('air_ext_auth0_token'); } catch {} }
// const STORED_EXT_AUTH0  = INITIAL_EXT_TOKEN ? null : loadExtAuth0Token();

// // Helper — check karo profile complete hai ya nahi
// function checkNeedsSetup(data) {
//   const name  = data.name  || '';
//   const email = data.email || '';
//   const nameInvalid = !name || name.trim() === '' || name === 'User' || name === email;
//   return !data.profileComplete || nameInvalid;
// }

// export const AppProvider = ({ children }) => {
//   const { isAuthenticated, getAccessTokenSilently, user ,logout: auth0Logout } = useAuth0();

//   const [extLoading,        setExtLoading]        = useState(!!INITIAL_EXT_TOKEN && !STORED_EXT_AUTH0);
//   const [extError,          setExtError]          = useState(null);
//   const [extToken,          setExtToken]          = useState(INITIAL_EXT_JWT || STORED_EXT_AUTH0);
//   const [currentUser,       setCurrentUser]       = useState(null);
//   const [annotations,       setAnnotations]       = useState([]);
//   const [readingTheme,      setReadingThemeState] = useState('light');
//   const [fontSize,          setFontSizeState]     = useState(15);
//   const [sidebarOpen,       setSidebarOpen]       = useState(false);
//   const [notifications,     setNotifications]     = useState([]);
//   const [needsProfileSetup, setNeedsProfileSetup] = useState(false);

//   // Save ext_jwt from URL (new tab from openReader)
//   useEffect(() => {
//     if (INITIAL_EXT_JWT) {
//       saveExtAuth0Token(INITIAL_EXT_JWT);
//       setExtToken(INITIAL_EXT_JWT);
//       try {
//         const clean = new URL(window.location.href);
//         clean.searchParams.delete('ext_jwt');
//         window.history.replaceState({}, '', clean.toString());
//       } catch {}
//     }
//   }, []);

//   // getToken
//   const getToken = useCallback(async () => {
//     if (isAuthenticated) {
//       const t = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE } });
//       window.__AIR_ACCESS_TOKEN__ = t;
//       return t;
//     }
//     const stored = extToken || loadExtAuth0Token();
//     if (stored) { window.__AIR_ACCESS_TOKEN__ = stored; return stored; }
//     throw new Error('Not authenticated');
//   }, [isAuthenticated, getAccessTokenSilently, extToken]);

//   // External SSO boot (?token= in URL)
//   useEffect(() => {
//     if (!INITIAL_EXT_TOKEN) return;
//     setExtLoading(true); setExtError(null);
//     (async () => {
//       try {
//         const apiBase = process.env.REACT_APP_API_URL || '';
//         const resp = await fetch(`${apiBase}/auth/external-sso`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ token: INITIAL_EXT_TOKEN }),
//         });
//         const data = await resp.json().catch(() => ({ success: false, message: 'Invalid response' }));
//         if (!resp.ok || !data.success) throw new Error(data.message || `Auth failed (HTTP ${resp.status})`);
//         saveExtAuth0Token(data.access_token);
//         setExtToken(data.access_token);
//         const u = data.user;
//         setCurrentUser({ ...u, initials: (u.name || 'U').split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2), plan: u.plan || 'Free' });
//         setNeedsProfileSetup(checkNeedsSetup(u));
//         if (u.readingTheme) setReadingThemeState(u.readingTheme);
//         if (u.fontSize)     setFontSizeState(u.fontSize);
//         try { const clean = new URL(window.location.href); clean.searchParams.delete('token'); window.history.replaceState({}, '', clean.toString()); } catch {}
//         console.log('[AppContext] External SSO success:', u.email);
//       } catch (err) {
//         console.error('[AppContext] External SSO failed:', err.message);
//         setExtError(err.message);
//         clearExtAuth0Token();
//         setExtToken(null);
//       } finally { setExtLoading(false); }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Auth0 user load
//   useEffect(() => {
//     if (!isAuthenticated) return;
//     if (currentUser) return;
//     (async () => {
//       try {
//         const token = await getToken();
//         const res   = await usersAPI.getMe(token);
//         const name  = res.data.name  || '';
//         const email = res.data.email || user?.email || '';
//         if ((!res.data.name || !res.data.email) && (user?.name || user?.email)) {
//           await usersAPI.updateMe(token, { name: user.name || '', email: user.email || '' });
//         }
//         const loadedUser = {
//           ...res.data, name, email,
//           initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U',
//           plan: res.data.plan || 'Free',
//         };
//         setCurrentUser(loadedUser);
//         setNeedsProfileSetup(checkNeedsSetup(res.data));
//         if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
//         if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
//       } catch (e) { console.error('[AppContext] User load:', e); }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAuthenticated]);

//   // extToken user load (email/password login — isAuthenticated is false)
//   useEffect(() => {
//     if (isAuthenticated) return;  // Auth0 user — handled above
//     if (!extToken)       return;  // no token
//     if (currentUser)     return;  // already loaded
//     if (extLoading)      return;  // still loading external SSO
//     (async () => {
//       try {
//         const res = await usersAPI.getMe(extToken);
//         const name  = res.data.name  || '';
//         const email = res.data.email || '';
//         const loadedUser = {
//           ...res.data, name, email,
//           initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U',
//           plan: res.data.plan || 'Free',
//         };
//         setCurrentUser(loadedUser);
//         setNeedsProfileSetup(checkNeedsSetup(res.data));
//         if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
//         if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
//       } catch (e) {
//         console.error('[AppContext] extToken user load:', e);
//         clearExtAuth0Token();
//         setExtToken(null);
//       }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAuthenticated, extToken, extLoading]);

//   // Annotations
//   useEffect(() => {
//     const ready = isAuthenticated || (!!extToken && !extLoading);
//     if (!ready) return;
//     (async () => {
//       try { const token = await getToken(); const res = await notebooksAPI.getAll(token); setAnnotations(res.data || []); }
//       catch (e) { console.error('[AppContext] Annotations:', e); }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAuthenticated, extToken, extLoading]);

//   // Notifications
//   useEffect(() => {
//     const ready = isAuthenticated || (!!extToken && !extLoading);
//     if (!ready) return;
//     const notifs = [];
//     if (annotations.length > 0) notifs.push({ id: 'n-annot', text: `You have ${annotations.length} saved annotations`, time: 'Now', read: true });
//     notifs.push({ id: 'n-welcome', text: 'Welcome to AIR Reader — explore 428+ legal books', time: 'Always', read: true });
//     setNotifications(notifs);
//   }, [isAuthenticated, annotations.length, extToken, extLoading]);

//   // Logout
//  const logout = useCallback(() => {
//     // Clear all stored tokens
//     try { localStorage.removeItem('air_ext_auth0_token'); } catch {}
//     try { localStorage.removeItem('air_external_jwt'); } catch {}
//     try { localStorage.clear(); } catch {}
//     delete window.__AIR_ACCESS_TOKEN__;
 
//     // Clear state
//     setExtToken(null);
//     setCurrentUser(null);
//     setAnnotations([]);
//     setNeedsProfileSetup(false);
 
//     // If Auth0 user — use Auth0 logout (clears Auth0 session)
//     // If external token user — just redirect to origin
//     if (isAuthenticated) {
//       auth0Logout({ logoutParams: { returnTo: window.location.origin } });
//     } else {
//       window.location.href = window.location.origin;
//     }
//   }, [isAuthenticated, auth0Logout]);

// const addAnnotation = useCallback(async (ann) => {
//     try { 
//       const t = await getToken(); 
//       const res = await notebooksAPI.create(t, ann);
//       if (res.data) {
//         setAnnotations(prev => [res.data, ...prev]);
//         // Dusre tab ko notify karo
//         localStorage.setItem('air_annotation_added', Date.now().toString());
//       }
//     }
//     catch (e) { console.error('[AppContext] addAnnotation:', e); }
//   }, [getToken]);
//   const removeAnnotation = useCallback(async (id) => {
//     try { const t = await getToken(); await notebooksAPI.remove(t, id); setAnnotations(prev => prev.filter(a => String(a._id) !== String(id))); }
//     catch (e) { console.error('[AppContext] removeAnnotation:', e); }
//   }, [getToken]);


//   // Dusre tab se annotation aane pe refresh karo
// useEffect(() => {
//   const handleStorage = async (e) => {
//     if (e.key === 'air_annotation_added') {
//       try {
//         const token = await getToken();
//         const res = await notebooksAPI.getAll(token);
//         setAnnotations(res.data || []);
//       } catch {}
//     }
//   };
//   window.addEventListener('storage', handleStorage);
//   return () => window.removeEventListener('storage', handleStorage);
// }, [getToken]);


// useEffect(() => {
//   const handleStorage = async (e) => {
//     if (e.key === 'air_annotation_added') {
//       try {
//         const token = await getToken();
//         const res = await notebooksAPI.getAll(token);
//         setAnnotations(res.data || []);
//       } catch {}
//     }
//     if (e.key === 'air_bookmark_changed') {
//       try {
//         const token = await getToken();
//         const res = await usersAPI.getMe(token);
//         setCurrentUser(prev => ({ ...prev, bookmarks: res.data?.bookmarks || [] }));
//       } catch {}
//     }
//   };
//   window.addEventListener('storage', handleStorage);
//   return () => window.removeEventListener('storage', handleStorage);
// }, [getToken]);
// const toggleBookmark = useCallback(async (bookId, chapterId, scrollTop) => {
//     const id = String(bookId);
//     setCurrentUser(prev => {
//       const bms = (prev?.bookmarks || []).map(String);
//       return { ...prev, bookmarks: bms.includes(id) ? bms.filter(b => b !== id) : [...bms, id] };
//     });
//     try {
//       const t = await getToken();
//       await usersAPI.toggleBookmark(t, bookId, { chapterId, scrollTop });
//       const meRes = await usersAPI.getMe(t);
//       setCurrentUser(prev => ({
//         ...prev,
//         bookmarks: (meRes.data?.bookmarks || []).map(String),
//         bookmarkPos: meRes.data?.bookmarkPos || {}
//       }));
//       localStorage.setItem('air_bookmark_changed', Date.now().toString());
//     } catch (e) { console.error('[AppContext] toggleBookmark:', e); }
//   }, [getToken]);
//   const toggleDownload = useCallback(async (bookId) => {
//     try {
//       const t = await getToken(); await usersAPI.toggleDownload(t, bookId);
//       setCurrentUser(prev => { const dls = prev?.downloads || []; return { ...prev, downloads: dls.includes(bookId) ? dls.filter(d => d !== bookId) : [...dls, bookId] }; });
//     } catch (e) { console.error('[AppContext] toggleDownload:', e); }
//   }, [getToken]);

//   const saveProgress = useCallback(async (bookId, percent, chapterId) => {
//     try {
//       const t = await getToken(); await usersAPI.saveProgress(t, { bookId, percent, chapterId });
//       setCurrentUser(prev => ({ ...prev, progress: { ...(prev?.progress || {}), [bookId]: { percent, chapterId } } }));
//     } catch (e) { console.error('[AppContext] saveProgress:', e); }
//   }, [getToken]);

//   const setReadingTheme = useCallback(async (theme) => {
//     setReadingThemeState(theme);
//     try { const t = await getToken(); await usersAPI.updateMe(t, { readingTheme: theme }); } catch {}
//   }, [getToken]);

//   const setFontSize = useCallback(async (size) => {
//     setFontSizeState(size);
//     try { const t = await getToken(); await usersAPI.updateMe(t, { fontSize: size }); } catch {}
//   }, [getToken]);

//   const isLoggedIn = isAuthenticated || (!!extToken && !extLoading);

//   return (
//     <AppContext.Provider value={{
//       isLoggedIn, extLoading, extError,
//       needsProfileSetup, setNeedsProfileSetup,
//       currentUser, setCurrentUser, getToken, logout,
//       annotations, addAnnotation, removeAnnotation,
//       bookmarks:  currentUser?.bookmarks || [],
//       downloads:  currentUser?.downloads || [],
//       toggleBookmark, toggleDownload, saveProgress,
//       readingTheme, setReadingTheme,
//       fontSize, setFontSize,
//       sidebarOpen, setSidebarOpen,
//       notifications,
//     }}>
//       {children}
//     </AppContext.Provider>
//   );
// };

// export const useApp = () => useContext(AppContext);

// src/context/AppContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { usersAPI, notebooksAPI } from '../services/api';

const AppContext = createContext(null);

// AIROnline token (external SSO)
function getExternalTokenFromUrl() {
  try { return new URLSearchParams(window.location.search).get('token') || null; }
  catch { return null; }
}

// Mother App Auth0 token (direct)
function getAuth0TokenFromUrl() {
  try { return new URLSearchParams(window.location.search).get('auth0_token') || null; }
  catch { return null; }
}

function getExtJwtFromUrl() {
  try { return new URLSearchParams(window.location.search).get('ext_jwt') || null; }
  catch { return null; }
}

function getActiveParamFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('active') || params.get('isActive') || null;
  }
  catch { return null; }
}

const EXT_AUTH0_TOKEN_KEY = 'air_ext_auth0_token';
function saveExtAuth0Token(t) { try { localStorage.setItem(EXT_AUTH0_TOKEN_KEY, t); } catch {} window.__AIR_ACCESS_TOKEN__ = t; }
function loadExtAuth0Token() { try { return localStorage.getItem(EXT_AUTH0_TOKEN_KEY) || null; } catch { return null; } }
function clearExtAuth0Token() { try { localStorage.removeItem(EXT_AUTH0_TOKEN_KEY); } catch {} }

const INITIAL_EXT_TOKEN    = getExternalTokenFromUrl();   // AIROnline token
const INITIAL_AUTH0_TOKEN  = getAuth0TokenFromUrl();      // Mother App Auth0 token
const INITIAL_EXT_JWT      = getExtJwtFromUrl();
const INITIAL_ACTIVE_PARAM = getActiveParamFromUrl();

// Naya token aaya toh purana clear karo
if (INITIAL_EXT_TOKEN || INITIAL_AUTH0_TOKEN) {
  try { localStorage.removeItem('air_ext_auth0_token'); } catch {}
}

const STORED_EXT_AUTH0 = (INITIAL_EXT_TOKEN || INITIAL_AUTH0_TOKEN) ? null : loadExtAuth0Token();

function checkNeedsSetup(data) {
  const name  = data.name  || '';
  const email = data.email || '';
  const nameInvalid = !name || name.trim() === '' || name === 'User' || name === email;
  return !data.profileComplete || nameInvalid;
}

export const AppProvider = ({ children }) => {
  const { isAuthenticated, getAccessTokenSilently, user, logout: auth0Logout } = useAuth0();

  // Mother App Auth0 token — seedha store karo, SSO nahi
  const initialExtToken = INITIAL_AUTH0_TOKEN || INITIAL_EXT_JWT || STORED_EXT_AUTH0;

  const [extLoading,        setExtLoading]        = useState(!!INITIAL_EXT_TOKEN && !STORED_EXT_AUTH0);
  const [extError,          setExtError]          = useState(null);
  const [extToken,          setExtToken]          = useState(initialExtToken);
  const [currentUser,       setCurrentUser]       = useState(null);
  const [annotations,       setAnnotations]       = useState([]);
  const [readingTheme,      setReadingThemeState] = useState('light');
  const [fontSize,          setFontSizeState]     = useState(15);
  const [sidebarOpen,       setSidebarOpen]       = useState(false);
  const [notifications,     setNotifications]     = useState([]);
  const [needsProfileSetup, setNeedsProfileSetup] = useState(false);

  // ── Mother App Auth0 token — seedha save karo ──────────────────────────────
  useEffect(() => {
    if (!INITIAL_AUTH0_TOKEN) return;
    console.log('[AppContext] Mother App Auth0 token received — saving directly');
    saveExtAuth0Token(INITIAL_AUTH0_TOKEN);
    setExtToken(INITIAL_AUTH0_TOKEN);
    try {
      const clean = new URL(window.location.href);
      clean.searchParams.delete('auth0_token');
      window.history.replaceState({}, '', clean.toString());
    } catch {}
  }, []);

  // ── ext_jwt from URL (reader new tab) ─────────────────────────────────────
  useEffect(() => {
    if (INITIAL_EXT_JWT) {
      saveExtAuth0Token(INITIAL_EXT_JWT);
      setExtToken(INITIAL_EXT_JWT);
      try {
        const clean = new URL(window.location.href);
        clean.searchParams.delete('ext_jwt');
        window.history.replaceState({}, '', clean.toString());
      } catch {}
    }
  }, []);

  // getToken
  const getToken = useCallback(async () => {
    if (isAuthenticated) {
      const t = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE } });
      window.__AIR_ACCESS_TOKEN__ = t;
      return t;
    }
    const stored = extToken || loadExtAuth0Token();
    if (stored) { window.__AIR_ACCESS_TOKEN__ = stored; return stored; }
    throw new Error('Not authenticated');
  }, [isAuthenticated, getAccessTokenSilently, extToken]);

  // ── AIROnline External SSO boot (?token= in URL) ───────────────────────────
  useEffect(() => {
    if (!INITIAL_EXT_TOKEN) return;
    // Mother App token already handled above — skip
    if (INITIAL_AUTH0_TOKEN) return;

    setExtLoading(true); setExtError(null);
    (async () => {
      try {
        const apiBase = process.env.REACT_APP_API_URL || '';
        const resp = await fetch(`${apiBase}/auth/external-sso`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: INITIAL_EXT_TOKEN, active: INITIAL_ACTIVE_PARAM }),
        });
        const data = await resp.json().catch(() => ({ success: false, message: 'Invalid response' }));
        if (!resp.ok || !data.success) throw new Error(data.message || `Auth failed (HTTP ${resp.status})`);
        saveExtAuth0Token(data.access_token);
        setExtToken(data.access_token);
        const u = data.user;
        setCurrentUser({ ...u, initials: (u.name || 'U').split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2), plan: u.plan || 'Free' });
        setNeedsProfileSetup(checkNeedsSetup(u));
        if (u.readingTheme) setReadingThemeState(u.readingTheme);
        if (u.fontSize)     setFontSizeState(u.fontSize);
        try {
          const clean = new URL(window.location.href);
          clean.searchParams.delete('token');
          clean.searchParams.delete('active');
          clean.searchParams.delete('isActive');
          window.history.replaceState({}, '', clean.toString());
        } catch {}
        console.log('[AppContext] AIROnline SSO success');
      } catch (err) {
        console.error('[AppContext] External SSO failed:', err.message);
        setExtError(err.message);
        clearExtAuth0Token();
        setExtToken(null);
      } finally { setExtLoading(false); }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auth0 user load
  useEffect(() => {
    if (!isAuthenticated) return;
    if (currentUser) return;
    (async () => {
      try {
        const token = await getToken();
        const res   = await usersAPI.getMe(token);
        const name  = res.data.name  || '';
        const email = res.data.email || user?.email || '';
        if ((!res.data.name || !res.data.email) && (user?.name || user?.email)) {
          await usersAPI.updateMe(token, { name: user.name || '', email: user.email || '' });
        }
        const loadedUser = { ...res.data, name, email, initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U', plan: res.data.plan || 'Free' };
        setCurrentUser(loadedUser);
        setNeedsProfileSetup(checkNeedsSetup(res.data));
        if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
        if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
      } catch (e) { console.error('[AppContext] User load:', e); }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  // extToken user load
  useEffect(() => {
    if (isAuthenticated) return;
    if (!extToken)       return;
    if (currentUser)     return;
    if (extLoading)      return;
    (async () => {
      try {
        const res = await usersAPI.getMe(extToken);
        const name  = res.data.name  || '';
        const email = res.data.email || '';
        const loadedUser = { ...res.data, name, email, initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U', plan: res.data.plan || 'Free' };
        setCurrentUser(loadedUser);
        setNeedsProfileSetup(checkNeedsSetup(res.data));
        if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
        if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
      } catch (e) {
        console.error('[AppContext] extToken user load:', e);
        clearExtAuth0Token();
        setExtToken(null);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, extToken, extLoading]);

  // Annotations
  useEffect(() => {
    const ready = isAuthenticated || (!!extToken && !extLoading);
    if (!ready) return;
    (async () => {
      try { const token = await getToken(); const res = await notebooksAPI.getAll(token); setAnnotations(res.data || []); }
      catch (e) { console.error('[AppContext] Annotations:', e); }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, extToken, extLoading]);

  // Notifications
  useEffect(() => {
    const ready = isAuthenticated || (!!extToken && !extLoading);
    if (!ready) return;
    const notifs = [];
    if (annotations.length > 0) notifs.push({ id: 'n-annot', text: `You have ${annotations.length} saved annotations`, time: 'Now', read: true });
    notifs.push({ id: 'n-welcome', text: 'Welcome to AIR Reader — explore 428+ legal books', time: 'Always', read: true });
    setNotifications(notifs);
  }, [isAuthenticated, annotations.length, extToken, extLoading]);

  // Logout
  const logout = useCallback(() => {
    try { localStorage.removeItem('air_ext_auth0_token'); } catch {}
    try { localStorage.removeItem('air_external_jwt'); } catch {}
    try { localStorage.clear(); } catch {}
    delete window.__AIR_ACCESS_TOKEN__;
    setExtToken(null);
    setCurrentUser(null);
    setAnnotations([]);
    setNeedsProfileSetup(false);
    if (isAuthenticated) {
      auth0Logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      window.location.href = window.location.origin;
    }
  }, [isAuthenticated, auth0Logout]);

  const addAnnotation = useCallback(async (ann) => {
    try {
      const t = await getToken();
      const res = await notebooksAPI.create(t, ann);
      if (res.data) { setAnnotations(prev => [res.data, ...prev]); localStorage.setItem('air_annotation_added', Date.now().toString()); }
    } catch (e) { console.error('[AppContext] addAnnotation:', e); }
  }, [getToken]);

  const removeAnnotation = useCallback(async (id) => {
    try { const t = await getToken(); await notebooksAPI.remove(t, id); setAnnotations(prev => prev.filter(a => String(a._id) !== String(id))); }
    catch (e) { console.error('[AppContext] removeAnnotation:', e); }
  }, [getToken]);

  useEffect(() => {
    const handleStorage = async (e) => {
      if (e.key === 'air_annotation_added') {
        try { const token = await getToken(); const res = await notebooksAPI.getAll(token); setAnnotations(res.data || []); } catch {}
      }
      if (e.key === 'air_bookmark_changed') {
        try { const token = await getToken(); const res = await usersAPI.getMe(token); setCurrentUser(prev => ({ ...prev, bookmarks: res.data?.bookmarks || [] })); } catch {}
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [getToken]);

  const toggleBookmark = useCallback(async (bookId, chapterId, scrollTop) => {
    const id = String(bookId);
    setCurrentUser(prev => { const bms = (prev?.bookmarks || []).map(String); return { ...prev, bookmarks: bms.includes(id) ? bms.filter(b => b !== id) : [...bms, id] }; });
    try {
      const t = await getToken();
      await usersAPI.toggleBookmark(t, bookId, { chapterId, scrollTop });
      const meRes = await usersAPI.getMe(t);
      setCurrentUser(prev => ({ ...prev, bookmarks: (meRes.data?.bookmarks || []).map(String), bookmarkPos: meRes.data?.bookmarkPos || {} }));
      localStorage.setItem('air_bookmark_changed', Date.now().toString());
    } catch (e) { console.error('[AppContext] toggleBookmark:', e); }
  }, [getToken]);

  const toggleDownload = useCallback(async (bookId) => {
    try {
      const t = await getToken(); await usersAPI.toggleDownload(t, bookId);
      setCurrentUser(prev => { const dls = prev?.downloads || []; return { ...prev, downloads: dls.includes(bookId) ? dls.filter(d => d !== bookId) : [...dls, bookId] }; });
    } catch (e) { console.error('[AppContext] toggleDownload:', e); }
  }, [getToken]);

  const saveProgress = useCallback(async (bookId, percent, chapterId) => {
    try {
      const t = await getToken(); await usersAPI.saveProgress(t, { bookId, percent, chapterId });
      setCurrentUser(prev => ({ ...prev, progress: { ...(prev?.progress || {}), [bookId]: { percent, chapterId } } }));
    } catch (e) { console.error('[AppContext] saveProgress:', e); }
  }, [getToken]);

  const setReadingTheme = useCallback(async (theme) => {
    setReadingThemeState(theme);
    try { const t = await getToken(); await usersAPI.updateMe(t, { readingTheme: theme }); } catch {}
  }, [getToken]);

  const setFontSize = useCallback(async (size) => {
    setFontSizeState(size);
    try { const t = await getToken(); await usersAPI.updateMe(t, { fontSize: size }); } catch {}
  }, [getToken]);

  const isLoggedIn = isAuthenticated || (!!extToken && !extLoading);

  return (
    <AppContext.Provider value={{
      isLoggedIn, extLoading, extError,
      needsProfileSetup, setNeedsProfileSetup,
      currentUser, setCurrentUser, getToken, logout,
      annotations, addAnnotation, removeAnnotation,
      bookmarks:  currentUser?.bookmarks || [],
      downloads:  currentUser?.downloads || [],
      toggleBookmark, toggleDownload, saveProgress,
      readingTheme, setReadingTheme,
      fontSize, setFontSize,
      sidebarOpen, setSidebarOpen,
      notifications,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// // // src/context/AppContext.js — Final v4
// // // Auth0 only — external SSO now returns real Auth0 JWT
// // // So isAuthenticated + getAccessTokenSilently works for everyone

// // import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// // import { useAuth0 } from '@auth0/auth0-react';
// // import { usersAPI, notebooksAPI } from '../services/api';

// // const AppContext = createContext(null);

// // // ── External SSO boot helper ──────────────────────────────────────────────────
// // // When user arrives with ?token= we call our backend which returns Auth0 JWT.
// // // We then inject it into Auth0 SDK using loginWithRedirect silent approach.
// // // Actually: we store the access_token and use it directly — no redirect needed.

// // const EXT_PENDING_KEY = 'air_ext_token_pending'; // aironline token waiting to be processed

// // function getExternalTokenFromUrl() {
// //   try { return new URLSearchParams(window.location.search).get('token') || null; }
// //   catch { return null; }
// // }

// // function getExtJwtFromUrl() {
// //   try { return new URLSearchParams(window.location.search).get('ext_jwt') || null; }
// //   catch { return null; }
// // }

// // // Stored Auth0 token for external SSO users (until Auth0 SDK takes over)
// // const EXT_AUTH0_TOKEN_KEY = 'air_ext_auth0_token';
// // function saveExtAuth0Token(t) { try { localStorage.setItem(EXT_AUTH0_TOKEN_KEY, t); } catch {} window.__AIR_ACCESS_TOKEN__ = t; }
// // function loadExtAuth0Token() { try { return localStorage.getItem(EXT_AUTH0_TOKEN_KEY) || null; } catch { return null; } }
// // function clearExtAuth0Token() { try { localStorage.removeItem(EXT_AUTH0_TOKEN_KEY); } catch {} }

// // const INITIAL_EXT_TOKEN   = getExternalTokenFromUrl();
// // const INITIAL_EXT_JWT     = getExtJwtFromUrl();
// // const STORED_EXT_AUTH0    = loadExtAuth0Token();

// // export const AppProvider = ({ children }) => {
// //   const { isAuthenticated, getAccessTokenSilently, user, loginWithRedirect } = useAuth0();

// //   // External SSO state
// //   const [extLoading,  setExtLoading]  = useState(!!INITIAL_EXT_TOKEN && !STORED_EXT_AUTH0);
// //   const [extError,    setExtError]    = useState(null);
// //   const [extToken,    setExtToken]    = useState(INITIAL_EXT_JWT || STORED_EXT_AUTH0);

// //   // App state
// //   const [currentUser,      setCurrentUser]      = useState(null);
// //   const [annotations,      setAnnotations]      = useState([]);
// //   const [readingTheme,     setReadingThemeState] = useState('light');
// //   const [fontSize,         setFontSizeState]     = useState(15);
// //   const [sidebarOpen,      setSidebarOpen]       = useState(false);
// //   const [notifications,    setNotifications]     = useState([]);

// //   // Save ext_jwt from URL (new tab from openReader)
// //   useEffect(() => {
// //     if (INITIAL_EXT_JWT) {
// //       saveExtAuth0Token(INITIAL_EXT_JWT);
// //       setExtToken(INITIAL_EXT_JWT);
// //       try {
// //         const clean = new URL(window.location.href);
// //         clean.searchParams.delete('ext_jwt');
// //         window.history.replaceState({}, '', clean.toString());
// //       } catch {}
// //     }
// //   }, []);

// //   // ── getToken: Auth0 first, then fallback to stored external token ──────────
// //   const getToken = useCallback(async () => {
// //     // If Auth0 is authenticated — always use Auth0 (works for both normal + external SSO users)
// //     if (isAuthenticated) {
// //       const t = await getAccessTokenSilently({
// //         authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE },
// //       });
// //       window.__AIR_ACCESS_TOKEN__ = t;
// //       return t;
// //     }
// //     // Fallback: stored external token (while Auth0 is still loading)
// //     const stored = extToken || loadExtAuth0Token();
// //     if (stored) { window.__AIR_ACCESS_TOKEN__ = stored; return stored; }
// //     throw new Error('Not authenticated');
// //   }, [isAuthenticated, getAccessTokenSilently, extToken]);

// //   // ── External SSO boot — runs once when ?token= in URL ─────────────────────
// //   useEffect(() => {
// //     if (!INITIAL_EXT_TOKEN) return;

// //     setExtLoading(true);
// //     setExtError(null);

// //     (async () => {
// //       try {
// //         const apiBase = process.env.REACT_APP_API_URL || '';
// //         const resp = await fetch(`${apiBase}/auth/external-sso`, {
// //           method: 'POST',
// //           headers: { 'Content-Type': 'application/json' },
// //           body: JSON.stringify({ token: INITIAL_EXT_TOKEN }),
// //         });

// //         const data = await resp.json().catch(() => ({ success: false, message: 'Invalid response' }));

// //         if (!resp.ok || !data.success) {
// //           throw new Error(data.message || `Auth failed (HTTP ${resp.status})`);
// //         }

// //         // Store the real Auth0 access_token
// //         saveExtAuth0Token(data.access_token);
// //         setExtToken(data.access_token);

// //         // Set current user from response
// //         const u = data.user;
// //         setCurrentUser({
// //           ...u,
// //           initials: (u.name || 'U').split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2),
// //           plan: u.plan || 'Free',
// //         });
// //         if (u.readingTheme) setReadingThemeState(u.readingTheme);
// //         if (u.fontSize)     setFontSizeState(u.fontSize);

// //         // Clean URL
// //         try {
// //           const clean = new URL(window.location.href);
// //           clean.searchParams.delete('token');
// //           window.history.replaceState({}, '', clean.toString());
// //         } catch {}

// //         console.log('[AppContext] External SSO success:', u.email);
// //       } catch (err) {
// //         console.error('[AppContext] External SSO failed:', err.message);
// //         setExtError(err.message);
// //         clearExtAuth0Token();
// //         setExtToken(null);
// //       } finally {
// //         setExtLoading(false);
// //       }
// //     })();
// //   // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   // ── Auth0 user load ────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     if (!isAuthenticated) return;
// //     // If we already loaded from external SSO response, skip
// //     if (currentUser) return;

// //     (async () => {
// //       try {
// //         const token = await getToken();
// //         const res   = await usersAPI.getMe(token);
// //         const name  = res.data.name  || user?.name  || '';
// //         const email = res.data.email || user?.email || '';
// //         if ((!res.data.name || !res.data.email) && (user?.name || user?.email)) {
// //           await usersAPI.updateMe(token, { name: user.name || '', email: user.email || '' });
// //         }
// //         setCurrentUser({
// //           ...res.data, name, email,
// //           initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U',
// //           plan: res.data.plan || 'Free',
// //         });
// //         if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
// //         if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
// //       } catch (e) { console.error('[AppContext] User load:', e); }
// //     })();
// //   // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [isAuthenticated]);

// //   // ── Annotations load ───────────────────────────────────────────────────────
// //   useEffect(() => {
// //     const ready = isAuthenticated || (!!extToken && !extLoading);
// //     if (!ready) return;
// //     (async () => {
// //       try {
// //         const token = await getToken();
// //         const res   = await notebooksAPI.getAll(token);
// //         setAnnotations(res.data || []);
// //       } catch (e) { console.error('[AppContext] Annotations:', e); }
// //     })();
// //   // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [isAuthenticated, extToken, extLoading]);

// //   // ── Notifications ──────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     const ready = isAuthenticated || (!!extToken && !extLoading);
// //     if (!ready) return;
// //     const notifs = [];
// //     if (annotations.length > 0) notifs.push({ id: 'n-annot', text: `You have ${annotations.length} saved annotations`, time: 'Now', read: true });
// //     notifs.push({ id: 'n-welcome', text: 'Welcome to AIR Reader — explore 428+ legal books', time: 'Always', read: true });
// //     setNotifications(notifs);
// //   }, [isAuthenticated, annotations.length, extToken, extLoading]);

// //   // ── Actions ────────────────────────────────────────────────────────────────
// //   const addAnnotation = useCallback(async (ann) => {
// //     try { const t = await getToken(); const res = await notebooksAPI.create(t, ann); if (res.data) setAnnotations(prev => [res.data, ...prev]); }
// //     catch (e) { console.error('[AppContext] addAnnotation:', e); }
// //   }, [getToken]);

// //   const removeAnnotation = useCallback(async (id) => {
// //     try { const t = await getToken(); await notebooksAPI.remove(t, id); setAnnotations(prev => prev.filter(a => String(a._id) !== String(id))); }
// //     catch (e) { console.error('[AppContext] removeAnnotation:', e); }
// //   }, [getToken]);

// //   const toggleBookmark = useCallback(async (bookId) => {
// //     try {
// //       const t = await getToken(); await usersAPI.toggleBookmark(t, bookId);
// //       setCurrentUser(prev => { const bms = prev?.bookmarks || []; return { ...prev, bookmarks: bms.includes(bookId) ? bms.filter(b => b !== bookId) : [...bms, bookId] }; });
// //     } catch (e) { console.error('[AppContext] toggleBookmark:', e); }
// //   }, [getToken]);

// //   const toggleDownload = useCallback(async (bookId) => {
// //     try {
// //       const t = await getToken(); await usersAPI.toggleDownload(t, bookId);
// //       setCurrentUser(prev => { const dls = prev?.downloads || []; return { ...prev, downloads: dls.includes(bookId) ? dls.filter(d => d !== bookId) : [...dls, bookId] }; });
// //     } catch (e) { console.error('[AppContext] toggleDownload:', e); }
// //   }, [getToken]);

// //   const saveProgress = useCallback(async (bookId, percent, chapterId) => {
// //     try {
// //       const t = await getToken(); await usersAPI.saveProgress(t, { bookId, percent, chapterId });
// //       setCurrentUser(prev => ({ ...prev, progress: { ...(prev?.progress || {}), [bookId]: { percent, chapterId } } }));
// //     } catch (e) { console.error('[AppContext] saveProgress:', e); }
// //   }, [getToken]);

// //   const setReadingTheme = useCallback(async (theme) => {
// //     setReadingThemeState(theme);
// //     try { const t = await getToken(); await usersAPI.updateMe(t, { readingTheme: theme }); } catch {}
// //   }, [getToken]);

// //   const setFontSize = useCallback(async (size) => {
// //     setFontSizeState(size);
// //     try { const t = await getToken(); await usersAPI.updateMe(t, { fontSize: size }); } catch {}
// //   }, [getToken]);

// //   // isLoggedIn = Auth0 authenticated OR external token loaded
// //   const isLoggedIn = isAuthenticated || (!!extToken && !extLoading);

// //   return (
// //     <AppContext.Provider value={{
// //       isLoggedIn, extLoading, extError,
// //       currentUser, setCurrentUser, getToken,
// //       annotations, addAnnotation, removeAnnotation,
// //       bookmarks:  currentUser?.bookmarks || [],
// //       downloads:  currentUser?.downloads || [],
// //       toggleBookmark, toggleDownload, saveProgress,
// //       readingTheme, setReadingTheme,
// //       fontSize, setFontSize,
// //       sidebarOpen, setSidebarOpen,
// //       notifications,
// //     }}>
// //       {children}
// //     </AppContext.Provider>
// //   );
// // };

// // export const useApp = () => useContext(AppContext);







// // src/context/AppContext.js
// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import { useAuth0 } from '@auth0/auth0-react';
// import { usersAPI, notebooksAPI } from '../services/api';

// const AppContext = createContext(null);

// function getExternalTokenFromUrl() {
//   try { return new URLSearchParams(window.location.search).get('token') || null; }
//   catch { return null; }
// }
// function getExtJwtFromUrl() {
//   try { return new URLSearchParams(window.location.search).get('ext_jwt') || null; }
//   catch { return null; }
// }

// const EXT_AUTH0_TOKEN_KEY = 'air_ext_auth0_token';
// function saveExtAuth0Token(t) { try { localStorage.setItem(EXT_AUTH0_TOKEN_KEY, t); } catch {} window.__AIR_ACCESS_TOKEN__ = t; }
// function loadExtAuth0Token() { try { return localStorage.getItem(EXT_AUTH0_TOKEN_KEY) || null; } catch { return null; } }
// function clearExtAuth0Token() { try { localStorage.removeItem(EXT_AUTH0_TOKEN_KEY); } catch {} }

// const INITIAL_EXT_TOKEN = getExternalTokenFromUrl();
// const INITIAL_EXT_JWT   = getExtJwtFromUrl();
// // Agar naya token URL mein hai toh purana clear karo
// if (INITIAL_EXT_TOKEN) { try { localStorage.removeItem('air_ext_auth0_token'); } catch {} }
// const STORED_EXT_AUTH0  = INITIAL_EXT_TOKEN ? null : loadExtAuth0Token();

// // Helper — check karo profile complete hai ya nahi
// function checkNeedsSetup(data) {
//   const name  = data.name  || '';
//   const email = data.email || '';
//   const nameInvalid = !name || name.trim() === '' || name === 'User' || name === email;
//   return !data.profileComplete || nameInvalid;
// }

// export const AppProvider = ({ children }) => {
//   const { isAuthenticated, getAccessTokenSilently, user ,logout: auth0Logout } = useAuth0();

//   const [extLoading,        setExtLoading]        = useState(!!INITIAL_EXT_TOKEN && !STORED_EXT_AUTH0);
//   const [extError,          setExtError]          = useState(null);
//   const [extToken,          setExtToken]          = useState(INITIAL_EXT_JWT || STORED_EXT_AUTH0);
//   const [currentUser,       setCurrentUser]       = useState(null);
//   const [annotations,       setAnnotations]       = useState([]);
//   const [readingTheme,      setReadingThemeState] = useState('light');
//   const [fontSize,          setFontSizeState]     = useState(15);
//   const [sidebarOpen,       setSidebarOpen]       = useState(false);
//   const [notifications,     setNotifications]     = useState([]);
//   const [needsProfileSetup, setNeedsProfileSetup] = useState(false);

//   // Save ext_jwt from URL (new tab from openReader)
//   useEffect(() => {
//     if (INITIAL_EXT_JWT) {
//       saveExtAuth0Token(INITIAL_EXT_JWT);
//       setExtToken(INITIAL_EXT_JWT);
//       try {
//         const clean = new URL(window.location.href);
//         clean.searchParams.delete('ext_jwt');
//         window.history.replaceState({}, '', clean.toString());
//       } catch {}
//     }
//   }, []);

//   // getToken
//   const getToken = useCallback(async () => {
//     if (isAuthenticated) {
//       const t = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE } });
//       window.__AIR_ACCESS_TOKEN__ = t;
//       return t;
//     }
//     const stored = extToken || loadExtAuth0Token();
//     if (stored) { window.__AIR_ACCESS_TOKEN__ = stored; return stored; }
//     throw new Error('Not authenticated');
//   }, [isAuthenticated, getAccessTokenSilently, extToken]);

//   // External SSO boot (?token= in URL)
//   useEffect(() => {
//     if (!INITIAL_EXT_TOKEN) return;
//     setExtLoading(true); setExtError(null);
//     (async () => {
//       try {
//         const apiBase = process.env.REACT_APP_API_URL || '';
//         const resp = await fetch(`${apiBase}/auth/external-sso`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ token: INITIAL_EXT_TOKEN }),
//         });
//         const data = await resp.json().catch(() => ({ success: false, message: 'Invalid response' }));
//         if (!resp.ok || !data.success) throw new Error(data.message || `Auth failed (HTTP ${resp.status})`);
//         saveExtAuth0Token(data.access_token);
//         setExtToken(data.access_token);
//         const u = data.user;
//         setCurrentUser({ ...u, initials: (u.name || 'U').split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2), plan: u.plan || 'Free' });
//         setNeedsProfileSetup(checkNeedsSetup(u));
//         if (u.readingTheme) setReadingThemeState(u.readingTheme);
//         if (u.fontSize)     setFontSizeState(u.fontSize);
//         try { const clean = new URL(window.location.href); clean.searchParams.delete('token'); window.history.replaceState({}, '', clean.toString()); } catch {}
//         console.log('[AppContext] External SSO success:', u.email);
//       } catch (err) {
//         console.error('[AppContext] External SSO failed:', err.message);
//         setExtError(err.message);
//         clearExtAuth0Token();
//         setExtToken(null);
//       } finally { setExtLoading(false); }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Auth0 user load
//   useEffect(() => {
//     if (!isAuthenticated) return;
//     if (currentUser) return;
//     (async () => {
//       try {
//         const token = await getToken();
//         const res   = await usersAPI.getMe(token);
//         const name  = res.data.name  || '';
//         const email = res.data.email || user?.email || '';
//         if ((!res.data.name || !res.data.email) && (user?.name || user?.email)) {
//           await usersAPI.updateMe(token, { name: user.name || '', email: user.email || '' });
//         }
//         const loadedUser = {
//           ...res.data, name, email,
//           initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U',
//           plan: res.data.plan || 'Free',
//         };
//         setCurrentUser(loadedUser);
//         setNeedsProfileSetup(checkNeedsSetup(res.data));
//         if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
//         if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
//       } catch (e) { console.error('[AppContext] User load:', e); }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAuthenticated]);

//   // extToken user load (email/password login — isAuthenticated is false)
//   useEffect(() => {
//     if (isAuthenticated) return;  // Auth0 user — handled above
//     if (!extToken)       return;  // no token
//     if (currentUser)     return;  // already loaded
//     if (extLoading)      return;  // still loading external SSO
//     (async () => {
//       try {
//         const res = await usersAPI.getMe(extToken);
//         const name  = res.data.name  || '';
//         const email = res.data.email || '';
//         const loadedUser = {
//           ...res.data, name, email,
//           initials: name ? name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U',
//           plan: res.data.plan || 'Free',
//         };
//         setCurrentUser(loadedUser);
//         setNeedsProfileSetup(checkNeedsSetup(res.data));
//         if (res.data.readingTheme) setReadingThemeState(res.data.readingTheme);
//         if (res.data.fontSize)     setFontSizeState(res.data.fontSize);
//       } catch (e) {
//         console.error('[AppContext] extToken user load:', e);
//         clearExtAuth0Token();
//         setExtToken(null);
//       }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAuthenticated, extToken, extLoading]);

//   // Annotations
//   useEffect(() => {
//     const ready = isAuthenticated || (!!extToken && !extLoading);
//     if (!ready) return;
//     (async () => {
//       try { const token = await getToken(); const res = await notebooksAPI.getAll(token); setAnnotations(res.data || []); }
//       catch (e) { console.error('[AppContext] Annotations:', e); }
//     })();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAuthenticated, extToken, extLoading]);

//   // Notifications
//   useEffect(() => {
//     const ready = isAuthenticated || (!!extToken && !extLoading);
//     if (!ready) return;
//     const notifs = [];
//     if (annotations.length > 0) notifs.push({ id: 'n-annot', text: `You have ${annotations.length} saved annotations`, time: 'Now', read: true });
//     notifs.push({ id: 'n-welcome', text: 'Welcome to AIR Reader — explore 428+ legal books', time: 'Always', read: true });
//     setNotifications(notifs);
//   }, [isAuthenticated, annotations.length, extToken, extLoading]);

//   // Logout
//  const logout = useCallback(() => {
//     // Clear all stored tokens
//     try { localStorage.removeItem('air_ext_auth0_token'); } catch {}
//     try { localStorage.removeItem('air_external_jwt'); } catch {}
//     try { localStorage.clear(); } catch {}
//     delete window.__AIR_ACCESS_TOKEN__;
 
//     // Clear state
//     setExtToken(null);
//     setCurrentUser(null);
//     setAnnotations([]);
//     setNeedsProfileSetup(false);
 
//     // If Auth0 user — use Auth0 logout (clears Auth0 session)
//     // If external token user — just redirect to origin
//     if (isAuthenticated) {
//       auth0Logout({ logoutParams: { returnTo: window.location.origin } });
//     } else {
//       window.location.href = window.location.origin;
//     }
//   }, [isAuthenticated, auth0Logout]);

// const addAnnotation = useCallback(async (ann) => {
//     try { 
//       const t = await getToken(); 
//       const res = await notebooksAPI.create(t, ann);
//       if (res.data) {
//         setAnnotations(prev => [res.data, ...prev]);
//         // Dusre tab ko notify karo
//         localStorage.setItem('air_annotation_added', Date.now().toString());
//       }
//     }
//     catch (e) { console.error('[AppContext] addAnnotation:', e); }
//   }, [getToken]);
//   const removeAnnotation = useCallback(async (id) => {
//     try { const t = await getToken(); await notebooksAPI.remove(t, id); setAnnotations(prev => prev.filter(a => String(a._id) !== String(id))); }
//     catch (e) { console.error('[AppContext] removeAnnotation:', e); }
//   }, [getToken]);


//   // Dusre tab se annotation aane pe refresh karo
// useEffect(() => {
//   const handleStorage = async (e) => {
//     if (e.key === 'air_annotation_added') {
//       try {
//         const token = await getToken();
//         const res = await notebooksAPI.getAll(token);
//         setAnnotations(res.data || []);
//       } catch {}
//     }
//   };
//   window.addEventListener('storage', handleStorage);
//   return () => window.removeEventListener('storage', handleStorage);
// }, [getToken]);


// useEffect(() => {
//   const handleStorage = async (e) => {
//     if (e.key === 'air_annotation_added') {
//       try {
//         const token = await getToken();
//         const res = await notebooksAPI.getAll(token);
//         setAnnotations(res.data || []);
//       } catch {}
//     }
//     if (e.key === 'air_bookmark_changed') {
//       try {
//         const token = await getToken();
//         const res = await usersAPI.getMe(token);
//         setCurrentUser(prev => ({ ...prev, bookmarks: res.data?.bookmarks || [] }));
//       } catch {}
//     }
//   };
//   window.addEventListener('storage', handleStorage);
//   return () => window.removeEventListener('storage', handleStorage);
// }, [getToken]);
// const toggleBookmark = useCallback(async (bookId, chapterId, scrollTop) => {
//     const id = String(bookId);
//     setCurrentUser(prev => {
//       const bms = (prev?.bookmarks || []).map(String);
//       return { ...prev, bookmarks: bms.includes(id) ? bms.filter(b => b !== id) : [...bms, id] };
//     });
//     try {
//       const t = await getToken();
//       await usersAPI.toggleBookmark(t, bookId, { chapterId, scrollTop });
//       const meRes = await usersAPI.getMe(t);
//       setCurrentUser(prev => ({
//         ...prev,
//         bookmarks: (meRes.data?.bookmarks || []).map(String),
//         bookmarkPos: meRes.data?.bookmarkPos || {}
//       }));
//       localStorage.setItem('air_bookmark_changed', Date.now().toString());
//     } catch (e) { console.error('[AppContext] toggleBookmark:', e); }
//   }, [getToken]);
//   const toggleDownload = useCallback(async (bookId) => {
//     try {
//       const t = await getToken(); await usersAPI.toggleDownload(t, bookId);
//       setCurrentUser(prev => { const dls = prev?.downloads || []; return { ...prev, downloads: dls.includes(bookId) ? dls.filter(d => d !== bookId) : [...dls, bookId] }; });
//     } catch (e) { console.error('[AppContext] toggleDownload:', e); }
//   }, [getToken]);

//   const saveProgress = useCallback(async (bookId, percent, chapterId) => {
//     try {
//       const t = await getToken(); await usersAPI.saveProgress(t, { bookId, percent, chapterId });
//       setCurrentUser(prev => ({ ...prev, progress: { ...(prev?.progress || {}), [bookId]: { percent, chapterId } } }));
//     } catch (e) { console.error('[AppContext] saveProgress:', e); }
//   }, [getToken]);

//   const setReadingTheme = useCallback(async (theme) => {
//     setReadingThemeState(theme);
//     try { const t = await getToken(); await usersAPI.updateMe(t, { readingTheme: theme }); } catch {}
//   }, [getToken]);

//   const setFontSize = useCallback(async (size) => {
//     setFontSizeState(size);
//     try { const t = await getToken(); await usersAPI.updateMe(t, { fontSize: size }); } catch {}
//   }, [getToken]);

//   const isLoggedIn = isAuthenticated || (!!extToken && !extLoading);

//   return (
//     <AppContext.Provider value={{
//       isLoggedIn, extLoading, extError,
//       needsProfileSetup, setNeedsProfileSetup,
//       currentUser, setCurrentUser, getToken, logout,
//       annotations, addAnnotation, removeAnnotation,
//       bookmarks:  currentUser?.bookmarks || [],
//       downloads:  currentUser?.downloads || [],
//       toggleBookmark, toggleDownload, saveProgress,
//       readingTheme, setReadingTheme,
//       fontSize, setFontSize,
//       sidebarOpen, setSidebarOpen,
//       notifications,
//     }}>
//       {children}
//     </AppContext.Provider>
//   );
// };

// export const useApp = () => useContext(AppContext);